module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron jumbotron-fluid mt-5"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h2', {
    staticClass: "display-4"
  }, [_vm._v("Welcome to GetLocal")]), _vm._v(" "), _c('p', {
    staticClass: "lead"
  }, [_vm._v("Your account and tools are being setup.  You'll get an email when it's activated.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e9105c0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/components/Welcome.vue
// module id = 556
// module chunks = 1